import React from "react";

const TopBar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-[#8B1538] text-white py-2 px-4 shadow-md">
      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Quality Logo and Tagline */}
          <div className="flex items-center space-x-3">
            <img
              src="/quality-logo.png"
              alt="ISO 9001:2015"
              className="h-10 w-auto object-contain"
            />
            <div className="border-l border-white/30 pl-3">
              <span className="text-sm font-semibold tracking-wider">
                UV // LED SOLUTION PARTNER
              </span>
            </div>
          </div>

          {/* Right side - Contact info (optional) */}
          <div className="hidden md:flex items-center space-x-4 text-sm">
            <a href="tel:+917706994400" className="hover:text-red-200 transition-colors">
              📞 +91 7706994400
            </a>
            <span className="text-white/50">|</span>
            <a href="mailto:Crimson.inks7475@gmail.com" className="hover:text-red-200 transition-colors">
              ✉️ Crimson.inks7475@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
